<template>
      <div no-body class="lku-item"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else no-gutters>        
          <b-col md="6">
            <b-input-group>
                <b-input-group-prepend><span class="pt-2 mr-2">Filter</span></b-input-group-prepend>
                <b-form-input v-model="tblData.nomor" placeholder="Trx. Number" @keyup.13.native="refresh()"></b-form-input>
                <b-form-input v-model="tblData.pembeli" placeholder="Trading To(Buyer)" @keyup.13.native="refresh()" class="ml-1" style="width:40% !important;"></b-form-input>
            </b-input-group>                              
          </b-col>
          <b-col md="6">
            <b-input-group>
              <b-form-input v-model="tblData.uraian" placeholder="Trx.Description" @keyup.13.native="refresh()" class="ml-1"></b-form-input>
              <b-form-checkbox v-model="tblData.isclosed" value="0" unchecked-value="1" class="ml-2 pt-1">Trx. Open</b-form-checkbox>
              <b-input-group-append>
                  <b-btn text="Button" @click="clearFilter()" class="ml-3"> <i class="fa fa-eraser"></i>Clear</b-btn>
              </b-input-group-append>
            </b-input-group>                              
          </b-col>
      </b-row>
      <b-table
          class="m-0"
          ref="tblItem"
          responsive striped hover small
          style="font-size:smaller;" 
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(ttlamtdue)="data">
          <span v-if="(data.item.ttlamtdue)">{{data.item.matauang}} &nbsp;{{data.item.ttlamtdue|numFormat}}</span>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-item {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import trading from "../../apis/logistic_trading";
import moment from "moment";

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            thStyle: "width:100px",
            label: "Trading Number",
            sortable: true
          },
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Trading Date",
            sortable: true
          },
          {
            key: "pembeli",
            label: "Trading To(Buyer)",
            sortable: true
          },
          {
            key: "namaStore",
            label: "Store/Warehouse",
            sortable: true
          },
          {
            key: "ttlamtdue",
            label: "Total",
            sortable: true
          },
          {
            key: "createby",
            label: "Created By",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:moment().format('YYYY-MM-DD'),
        sortBy: 'nomor',
        sortDesc: false,
        isclosed: '0'
      },
      lkuLoading:false
    };
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.lkuLoading = false;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      const items= await trading.headtrx(this.tblData);    
      this.lkuLoading = false;
      return (items || []);      
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData.nomor=  '';
        this.tblData.pembeli=  '';
        this.tblData.uraian=  '';
        this.tblData.isclosed= '';
        this.refresh();
    },    
    refresh() {
      this.$refs.tblItem.refresh();
    }
  }
};
</script>
